export const whiteSpaceInputPattern = /[\S]/;
export const whiteSpaceAllPattern = /^\S+$/;
export const coderNamePattern = /^[a-zA-Z0-9][a-zA-Z0-9-]*$/;
export const urlDetectionPattern = /^(https?|ftp):\/\/[^\s/$.?#].[^\s]*$/;
export const protocolDisallowPattern =
  /^(?!(https?|[a-zA-Z][a-zA-Z0-9+.-]*:\/\/)).+/;
export const domainURLValidationRegex =
  /^(?:\*(?:\.[\p{L}\p{N}-]+)+\.[\p{L}\p{N}-]+|(?:[\p{L}\p{N}-]+(?:\.[\p{L}\p{N}-]+)+))(?!\.[^-])(?:[\p{L}\p{N}-]*\.[\p{L}\p{N}-]+[\p{L}\p{N}-]*)?$/u;
export const cidrRangePattern =
  /^(10\.(\d{1,3}\.){2}\d{1,3}\/(2[0-8]|[89]|1[0-9])|172\.(1[6-9]|2[0-9]|3[01])\.(\d{1,3}\.){1}\d{1,3}\/(2[0-8]|[12][0-9])|192\.168\.(\d{1,3}\.){1}\d{1,3}\/(2[0-8]|[12][0-9]|1[6-9]))$/;
